import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import username from 'flarum/common/helpers/username';
import Button from 'flarum/common/components/Button';
export default class DeleteUserModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "loadingAnonymization", false);
    _defineProperty(this, "loadingDeletion", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
  }
  className() {
    return 'DeleteUserModal Modal--small';
  }
  title() {
    return app.translator.trans('flarum-gdpr.forum.delete_user.title', {
      username: username(this.user)
    });
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.forum.delete_user.text', {
      username: username(this.user)
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.defaultErasure(),
      loading: this.loading,
      disabled: this.loading
    }, app.translator.trans('flarum-gdpr.forum.delete_user.modal_delete_button'))), app.forum.attribute('erasureAnonymizationAllowed') && app.forum.attribute('erasureDeletionAllowed') && m("div", null, m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--block",
      onclick: () => this.specificErasure('anonymization'),
      loading: this.loadingAnonymization,
      disabled: this.loadingAnonymization
    }, app.translator.trans('flarum-gdpr.forum.process_erasure.anonymization_button'))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--danger Button--block",
      onclick: () => this.specificErasure('deletion'),
      loading: this.loadingDeletion,
      disabled: this.loadingDeletion
    }, app.translator.trans('flarum-gdpr.forum.process_erasure.deletion_button'))))));
  }
  defaultErasure() {
    this.loading = true;
    this.user.delete().then(() => {
      this.hide();
      this.loading = false;
      m.redraw();
    }, () => {});
  }
  specificErasure(mode) {
    if (mode === 'anonymization') {
      this.loadingAnonymization = true;
    } else {
      this.loadingDeletion = true;
    }
    this.user.delete({
      gdprMode: mode
    }).then(() => {
      this.hide();
      this.loadingAnonymization = false;
      this.loadingDeletion = false;
      m.redraw();
    }, () => []);
  }
}
flarum.reg.add('flarum-gdpr', 'forum/components/DeleteUserModal', DeleteUserModal);